<template>
  <button class="btn btn-secondary" @click="$emit('click')" :disabled="isLoading">
    <div class="d-flex">
      <span
        :class="{
          'visually-hidden': !isLoading,
          'spinner-border spinner-border-sm col align-self-center mx-2': isLoading,
        }"
        role="status"
        aria-hidden="true"
      ></span>
      <BS-Icon
        v-if="icon"
        :_class="[
          icon,
          'col',
          'order-' + (iconOrientation === 'start' ? '0' : '3'),
          { 'visually-hidden': isLoading },
        ]"
      />
      <slot class="col"></slot>
    </div>
  </button>
</template>

<script>
import Icon from '@/Components/BS-Icon'

export default {
  name: 'ActionButton',
  components: { Icon },
  props: {
    isLoading: { type: Boolean, default: false },
    icon: String,
    iconOrientation: {
      type: String,
      default: 'start',
      validator: value => ['start', 'end'].indexOf(value) > -1,
    },
  },
}
</script>

<style lang="scss" scoped></style>
